/**
 * Copyright (c) 2024 Epinics (PVT) LTD
 * All Rights Reserved.
 * <p>
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * <p>
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * <p>
 */
import React, { useState } from "react";
import styles from "./index.module.css";
import stepOne from "../../../assets/step1.png";
import stepTwo from "../../../assets/step2.png";
import stepThree from "../../../assets/step3.png";
import { LiaChevronDownSolid, LiaChevronUpSolid } from "react-icons/lia";

// Redux
import { sampleAction } from "../../../actions";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const StepThreeForm = ({
  step,
  setStep,
  layout: {
    sampleState,
    companyName,
    mobileNumber,
    email,
    address,
    password,
    isLoading,
    isSubmittedSuccessfully,
    resCompnayId,
    resCompanyName,
    resCompanyUsername,
    resCompanyMobileNumber,
    resCompany,
    resBranch,
    resCashier,
  },
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const stepList = [
    {
      id: 1,
      image: stepOne,
      title: "DOWNLOAD THE APP",
      desc: "Download the Epinics Point of Sale Application from this page.",
    },
    {
      id: 2,
      image: stepTwo,
      title: "INSTALL THE APP USING EXE FILE",
      desc: "Double click on the epinics.exe file and install it on your PC.",
    },
    {
      id: 3,
      image: stepThree,
      title: "SIGN IN USING ROOT USER",
      desc: "Open the installed app and Sign in using root username and password you given when you setting up your account.",
    },
  ];

  return (
    <div className={styles.mainDiv}>
      <div className={styles.step}>Step 3/3</div>
      <div className={styles.welcome}>Welcome to Epinics Point of Sale</div>
      <div className={styles.subTitle}>Download and set-up in 3 minutes</div>
      <div className={styles.formDiv}>
        <div className={styles.row}>
          <div className={styles.formGroup}>
            <label htmlFor="companyName">Company Name</label>
            <input
              disabled
              type="text"
              id="companyName"
              placeholder={resCompanyName}
              style={{
                background: "#EDEDED",
                border: "none",
                fontWeight: "600",
              }}
            />
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.formGroup}>
            <label className={styles.labelTitle} htmlFor="rootUserName">
              Company Username
            </label>
            <input
              disabled
              type="text"
              id="rootUserName"
              placeholder={resCompanyUsername}
              style={{
                background: "#EDEDED",
                border: "none",
                fontWeight: "600",
                marginBottom: "10px",
              }}
            />
            <span style={{ fontWeight: "600" }}>Keep this securely stored</span>
          </div>
          <div className={styles.spacer}></div>
          <div className={styles.formGroup}>
            <label className={styles.labelTitle} htmlFor="address">
              Company Mobile Number
            </label>
            <input
              disabled
              type="text"
              id="address"
              placeholder={resCompanyMobileNumber}
              style={{
                background: "#EDEDED",
                border: "none",
                fontWeight: "600",
              }}
            />
          </div>
        </div>
      </div>

      <div style={{ marginTop: "50px" }}>
        <span className={styles.note}>NOTE:</span> Use the given username and
        password for the pos software initial setup. These credentials can only
        be changed after the Software setup is complete. Ensure they are
        securely stored until then.
      </div>

      <div className={styles.dropdown}>
        <div
          onClick={() => {
            setIsOpen(!isOpen);
          }}
          className={styles.top}
        >
          <div className={styles.topLeft}>
            <div className={styles.howToInstall}>How to Install?</div>
            <div className={styles.stepByStep}>
              3 Simple Step-by-Step Installation Guide
            </div>
          </div>
          <div className={styles.topRight}>
            {isOpen ? <LiaChevronUpSolid /> : <LiaChevronDownSolid />}
          </div>
        </div>
        {isOpen && (
          <div className={styles.bottom}>
            {stepList.map((item, index) => (
              <div className={styles.stepDiv}>
                <div className={styles.stepLeft}>
                  <div className={styles.numberCircle}>{item.id}</div>
                  <div className={styles.numberStep}>STEP</div>
                </div>
                <div className={styles.stepRight}>
                  <div className={styles.stepRightLeft}>
                    <img
                      className={styles.stepImg}
                      src={item.image}
                      alt="step-image"
                    />
                  </div>
                  <div className={styles.stepRightRight}>
                    <div className={styles.stepTitle}>{item.title}</div>
                    <div className={styles.stepDesc}>{item.desc}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={styles.dwnldBtnDiv}>
        <div className={styles.dwnldBtn}>DOWNLOAD</div>
      </div>
    </div>
  );
};

StepThreeForm.propTypes = {
  sampleAction: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  layout: state.layoutState,
});

export default connect(mapStateToProps, {
  sampleAction,
})(StepThreeForm);
